import { useEffect } from 'react';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import Card from 'developer-docs-mdx-components/components/Card';
import I18n from 'I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { GuideIllustration, ImageTextDisplay, GuideMediaBody } from './sharedStyledComponents';
import { apiGuidesNavConfig } from '../../config/nav/guides/apiGuides';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Media } from 'foundations-components/transitional/components/Media';
import { BulbIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ApiLandingPage() {
  useMetadata({
    title: I18n.text('developer-docs-ui.htmlTitles.apiReferenceOverview'),
    description: I18n.text('developer-docs-ui.metaDescriptions.apiReferenceOverview'),
    isContentLoaded: true
  });

  // If there are named exports as well, *.default needs to be used

  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'apiLandingPage',
      subscreen: 'apiLandingPage'
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.header"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.intro"
      })
    }), /*#__PURE__*/_jsx(GuideMediaBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.welcome"
      })
    }), /*#__PURE__*/_jsx(Alert, {
      marginBlockStart: "600",
      type: "tip",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.versioningAlertTitleText"
      }),
      use: "inline",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.versioningAlertBody"
      })
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsx(ImageTextDisplay, {
        text: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.apiLandingPage.benefits"
            })
          }), /*#__PURE__*/_jsxs(List, {
            styled: true,
            children: [/*#__PURE__*/_jsx(ListItem, {
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet1"
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet2"
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.apiLandingPage.benefitBullet3"
              })
            })]
          })]
        }),
        image: /*#__PURE__*/_jsx(GuideIllustration, {
          name: "api"
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.guides.header"
      })
    }), /*#__PURE__*/_jsxs(GuideMediaBody, {
      marginBlockEnd: "1200",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.apiLandingPage.guides.description"
      }), /*#__PURE__*/_jsxs(Media, {
        align: "center",
        marginBlockStart: "800",
        children: [/*#__PURE__*/_jsx(View, {
          paddingInlineEnd: "300",
          children: /*#__PURE__*/_jsx(BulbIcon, {
            size: "800",
            color: "icon-core-subtle"
          })
        }), /*#__PURE__*/_jsx(UIRouterLink, {
          to: apiGuidesNavConfig().commonPath,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.apiLandingPage.guides.link"
          })
        })]
      })]
    })]
  });
}
export default ApiLandingPage;